import { Grid } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import IGridComponent from '../../../components/grid/i-grid.component';
import { isEmpty, isNotEmptyArray } from '../../common/util.services';
import './workflow.component.scss';
import SelectWorkflow from './select-workflow.component';
import dayjs from 'dayjs';
import { getOwnershipBasedUsers } from '../../user/user.services';
import CostingPopup from './costing.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import GanttChart from './gantt-chart.component';
import TextComponent from '../../enquiry/enq-product/edit-text.component';
import QualityParamsComponent from '../../order/quality/quality-params.component';

const WorkflowComponent = (props: any) => {
  const [open, setOpen] = useState(false);
  const [openCosting, setOpenCosting] = useState(false);
  const [openGanttChart, setOpenGanttChart] = useState(false);
  const [addRowIndex, setAddRowIndex] = useState(0);
  const rows: GridRowsProp = [];
  const [workflow, setWorkflow] = useState(rows);
  const appContext = useContext(AppContext);
  const [users, setUsers] = useState<any>();
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [openCellValue, setOpenCellValue] = useState(false);
  const [cellTitle, setCellTitle] = useState('');
  const [cellLabel, setCellLabel] = useState('');
  const [cellValueRow, setCellValueRow] = useState(null);
  const [popupRowData, setPopupRowData] = useState(null);
  const [openQlty, setOpenQlty] = useState(false);
  const [linkId, setLinkId] = useState(null);

  const columns: GridColDef[] = [
    { field: 'serial', headerName: '#', filterable: false, editable: false, sortable: false, width: 5 },
    { 
      field: 'dependency', headerName: 'Dependency', filterable: false, sortable: false, width: 95, editable: false, type: 'string',
      valueSetter: (value, row) => { row.dependency = value; return value; }
    },
    { 
      field: 'inputCode', headerName: 'Code', filterable: false, editable: false, sortable: false, width: 100,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openSpecsPopup(params) }}>{params.row.inputCode}</div> }
    },
    { field: 'outputDesc', headerName: 'Output', filterable: false, editable: false, sortable: false, width: 165 },
    { field: 'owner', headerName: 'Owner', filterable: false, editable: true, sortable: false, width: 120, type: 'singleSelect',
      valueOptions: users, 
      valueFormatter: (owner: any) => owner, 
      valueSetter: (value, row) => { row.owner = value; return value; }
    },
    {
      field: 'plannedStartDate', headerName: 'Start (P)', filterable: false, editable: true, sortable: false, width: 100, type: 'date',
      valueFormatter: (plannedStartDate: any) => dayjs(plannedStartDate).format('DD-MMM-YY'),
      valueSetter: (value, row) => { row.plannedStartDate = value; return value; }
    },
    {
      field: 'plannedEndDate', headerName: 'End (P)', filterable: false, editable: false, sortable: false, width: 100, type: 'date',
      valueFormatter: (plannedEndDate: any) => dayjs(plannedEndDate).format('DD-MMM-YY'),
      valueGetter: (value, row) => { return calculatePlannedEndDate(row)},
    },
    { field: 'plannedTAT', headerName: 'TAT (P)', filterable: false, editable: true, sortable: false, width: 75, type: 'number',
      valueSetter: (value, row) => { row.plannedTAT = value; return value; }
    },
    /*{
      field: 'actualStartDate', headerName: 'Start (A)', filterable: false, editable: true, sortable: false, width: 100, type: 'date',
      valueFormatter: (actualStartDate: any) => dayjs(actualStartDate).format('DD-MMM-YY'),
      valueSetter: (value, row) => { row.actualStartDate = value; return value; }
    },
    {
      field: 'actualEndDate', headerName: 'End (A)', filterable: false, editable: true, sortable: false, width: 100, type: 'date',
      valueFormatter: (actualEndDate: any) => dayjs(actualEndDate).format('DD-MMM-YY'),
      valueSetter: (value, row) => { row.actualEndDate = value; return value; }
    },
    { field: 'actualTAT', headerName: 'TAT (A)', filterable: false, editable: false, sortable: false, width: 75,
      valueGetter: (value, row) => { return calculateActualTAT(row)},
    },*/
    { field: 'status', headerName: 'Status', filterable: false, editable: false, sortable: false, width: 75, type: 'singleSelect',
      valueOptions: ['New', 'In Progress', 'Completed'],
      valueFormatter: (status: any) => status, 
      valueSetter: (value, row) => { row.status = value; return value; }
    },
    { field: 'qltyParams', headerName: 'Qlty Approval', filterable: false, editable: false, sortable: false, width: 120 },
    { field: 'qltyStatus', headerName: 'Qlty Status', filterable: false, editable: false, sortable: false, width: 120 },
    { field: 'daysLeft', headerName: 'Days Left', filterable: false, editable: false, sortable: false, width: 75,
      valueGetter: (value, row) => { return calculateDaysLeft(row)},
    },
    { field: 'ageing', headerName: 'Ageing', filterable: false, editable: false, sortable: false, width: 60,
      valueGetter: (value, row) => { return calculateAgeing(row)},
    },
    { field: 'flowRemarks', headerName: 'Remarks', filterable: false, editable: false, sortable: false, width: 140, type: 'string',
      valueSetter: (value, row) => { row.flowRemarks = value; return value; }
    },
  ];

  useEffect(() => {
    if (isNotEmptyArray(props.workflow)) {
      setWorkflow(updateSerialNumber([...props.workflow]));
    }

    getOwnershipBasedUsers('Order', appContext,
      (response: any) => {
        setUsers(response.data);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
    });
  }, [props.workflow]);

  const openFlowPopup = (params: any) => {
    setAddRowIndex(0);
    setOpen(true);
  }

  function areDependenciesCompleted(row: any) {
    let array = row.dependency.split(',');
    for(let i = 0; i < array.length; ++i) {
      if('NA' === array[i]) {
        continue;
      }
      
      if('Approved' !== workflow[Number(array[i]) - 1].qltyStatus) {
        return false;
      }
    }

    return true;
  }

  const handleCellDoubleClick = (value: any) => {
    const field = value.field;
    if('flowRemarks' === field) {
      setCellValueRow(value.row);
      setCellTitle('Flow Remarks');
      setCellLabel('Flow Remarks');
      openCellValuePopup();
    } else if('qltyParams' === field) {
      if(isEmpty(value.row.rowId)) {
        //appContext.setDialogMessage('Save the schedule first to approve quality.');
      }
      else if('0 / 0' === value.row.qltyParams) {
        //appContext.setDialogMessage('Quality parameters not set. Set it in the order screen.');
      } else if (!areDependenciesCompleted(value.row)) {
        //appContext.setDialogMessage('Complete quality checks for dependencies first.');
      } else {
        setLinkId(value.row.id);
        setPopupRowData(value.row);
        //setOpenQlty(true);
      }
    }
  }

  const closeCellValuePopup = () => {
    setOpenCellValue(false);
  }

  const openCellValuePopup = () => {
    setOpenCellValue(true);
  }

  const openSpecsPopup = (params: any) => {
    setSpecsData(params.row);
    setOpenSpecs(true);
  }

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const openCostingPopup = () => {
    setOpenCosting(true);
  }

  const handleCloseCosting = () => {
    setOpenCosting(false);
  }
  
  const openGanttChartPopup = () => {
    setOpenGanttChart(true);
  }

  
  const handleCloseGanttChart = () => {
    setOpenGanttChart(false);
  }

  const calculatePlannedEndDate = (row: any) => {
    if (row) {
      row.plannedEndDate = dayjs(row.plannedStartDate).add(row.plannedTAT - 1, 'day');
      return row.plannedEndDate;
    }
  }

  /*const calculateActualTAT = (row: any) => {
    if (row) {
      row.actualTAT = dayjs(row.actualEndDate).diff(row.actualStartDate, 'day');
      return row.actualTAT;
    }
  }*/

  const calculateDaysLeft = (row: any) => {
    if (row) {
      let plannedEndDate = dayjs(row.plannedEndDate);
      let date1 = new Date(plannedEndDate.year(), plannedEndDate.month(), plannedEndDate.date());
      let date2 = new Date(dayjs().year(), dayjs().month(), dayjs().date());
      row.daysLeft = dayjs(date1).diff(dayjs(date2), 'day');
      return row.daysLeft;
    }
  }

  const calculateAgeing = (row: any) => {
    if (row) {
      let plannedStartDate = dayjs(row.plannedStartDate);
      let date1 = new Date(plannedStartDate.year(), plannedStartDate.month(), plannedStartDate.date());
      let date2 = new Date(dayjs().year(), dayjs().month(), dayjs().date());
      row.ageing = dayjs(date2).diff(dayjs(date1), 'day');
      if(row.ageing < 0) {
        row.ageing = 0;
      }
      return row.ageing;
    }
  }

  const updateSerialNumber = (updatedRow: any) => {
    if (isNotEmptyArray(updatedRow)) {
      updatedRow.forEach((element: any, index: number) => {
        element.serial = index + 1;
      });
    }
    return updatedRow;
  }

  const onRowSelection = (selectedRows: any) => {
    setOpen(false);
    selectedRows[0].status = 'New';
    const selectedRow = selectedRows[0];
    let updatedRow;

    const rows = [...workflow];
    rows.splice(addRowIndex, 0, selectedRow)
    updatedRow = updateSerialNumber(rows);
    setWorkflow(updatedRow);
    if (props.onRowSelection) {
      props.onRowSelection(updatedRow);
    }
  }

  const processRowUpdate = (updatedRow: any, originalRow: any) => {
    if (props.processRowUpdate) {
      props.processRowUpdate(originalRow);
    }
  }

  const handleDeleteAction = (row: any) => {
    const updatedRows = workflow.filter((r) => !(r.id === row.id));
    const serialRows = updateSerialNumber(updatedRows);
    setWorkflow(serialRows);
    if (props.onRowDelete) {
      props.onRowDelete(serialRows);
    }
  }

  const handleAddAction = (row: any) => {
    setAddRowIndex(+row.serial);
    setOpen(true);
  }
  
  const handleCloseQlty = () => {
    setOpenQlty(false);
  }

  const onCancel = (value: any) => {
    setOpenQlty(false);
  }

  const onOk = (approval: any, qltyStatus: any) => {
    workflow.forEach(element => {
      if(element.id === linkId) {
        element.qltyStatus = qltyStatus;
        element.qltyParams = approval;
      }
    });
    setOpenQlty(false);
  }
  
  return (
    <div>
      <Grid container spacing={1}>
        <IGridComponent title='Workflow' rows={workflow} columns={columns} getRowId={(row: any) => row.id}
          apiRef={props.apiRef} showAction={false} handleDeleteAction={handleDeleteAction} showEditAction={false} 
          showApproveAction={false} showAddAction={true} showDownAction={false} showUpAction={false} showAddBtn={false}
          handleAddAction={handleAddAction} addRow={openFlowPopup} hideFooterPagination={true} processRowUpdate={processRowUpdate}
          showExtBtn={true} extBtnText={'Cost'} extBtnAction={openCostingPopup} hideFooter={true} maxHeight={'59vh'}
          showExtBtn2={true} extBtn2Text={'Gantt'} extBtn2Action={openGanttChartPopup} cellDoubleClick={handleCellDoubleClick}/>
        <IDialogComponent onClose={handleClose} open={open} title='Select Workflow'
          dialogBody={<SelectWorkflow onRowSelection={onRowSelection} />}/>
        <IDialogComponent onClose={handleCloseCosting} open={openCosting} title='Costing Details'
          dialogBody={<CostingPopup costingId={props.costingId}/>}/>
        <IDialogComponent onClose={handleCloseGanttChart} open={openGanttChart} title='Gantt Chart'
          dialogBody={<GanttChart data={workflow}/>}/>
        <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
          dialogBody={<SpecsComponent data={specsData} />} />
        <IDialogComponent onClose={closeCellValuePopup} open={openCellValue} title={cellTitle}
          dialogBody={<TextComponent data={cellValueRow} close={closeCellValuePopup} label={cellLabel}/>} />
        <IDialogComponent onClose={handleCloseQlty} open={openQlty} title='Quality Parameters'
          dialogBody={<QualityParamsComponent specData={popupRowData} orderId={props.orderId} costingId={props.costingId} linkId={linkId}
                       onCancel={onCancel} onOk={onOk}/>} />
      </Grid>
    </div>
  );
}

export default WorkflowComponent;
